module.exports = __webpack_public_path__ + "docs/stability-fund-de3752.md";